import React from "react";

class InstallationBG extends React.Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="141.032"
        height="115.031"
        viewBox="0 0 141.032 115.031"
      >
        <path
          id="#tariffsSlideBaseBg"
          data-name="Shape 8 copy"
          className="cls-1"
          d="M735,378c15.063-24.344,90.514-21.137,112-10,41.522,21.523,18.926,70.168,5,86-26.528,30.159-78.268,22.211-97,8C737.733,448.9,720.974,400.667,735,378Z"
          transform="translate(-729.781 -359.594)"
          fill="currentColor"
        />
        <text
          y="50"
          transform="translate(69)"
          fill="currentColor"
          fontFamily="sans-serif"
          fontSize="15"
        >
          <tspan x="0" textAnchor="middle">
            «Базовый»
          </tspan>
          <tspan
            x="0"
            textAnchor="middle"
            dy="15"
            id="tarrifsSlideTariffPrice"
          >
            1500 руб/месяц
          </tspan>
        </text>
      </svg>
    );
  }
}

export default InstallationBG;
